(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  const initializeBrivarCollectionCarousels = (root = document) => {
    root.querySelectorAll('.brivar-home-collection').forEach((section) => {
      const footer = section.querySelector('[data-brivar-carousel-footer]');
      if (!footer || footer.dataset.initialized === 'true') return;
      footer.dataset.initialized = 'true';
      const track = footer.querySelector('.brivar-home-collection__track');
      const progress = footer.querySelector('[data-brivar-carousel-progress]');
      const previous = footer.querySelector('[data-brivar-carousel-direction="previous"]');
      const next = footer.querySelector('[data-brivar-carousel-direction="next"]');
      /* BRIVAR 16/10/2026: pega só o carrossel da seção (não o carrossel de fotos de dentro dos cards) */
      const SCROLLER = '.resource-list__carousel > slideshow-component > slideshow-container > slideshow-slides';
      const activeScroller = () => {
        const panel = Array.from(section.querySelectorAll('.brivar-living-products-panel')).find((item) => !item.hidden);
        const visible = (el) => el && el.getBoundingClientRect().width > 0;
        const inPanel = panel ? Array.from(panel.querySelectorAll(SCROLLER)).find(visible) : null;
        return inPanel || Array.from(section.querySelectorAll(SCROLLER)).find(visible) || section.querySelector('slideshow-slides');
      };
      const update = () => {
        const scroller = activeScroller();
        if (!scroller) return;
        const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
        const value = max ? Math.min(100, (scroller.scrollLeft / max) * 100) : 100;
        const coverage = scroller.scrollWidth ? Math.min(100, ((scroller.scrollLeft + scroller.clientWidth) / scroller.scrollWidth) * 100) : 100;
        progress.style.width = coverage + '%';
        track.setAttribute('aria-valuenow', String(Math.round(value)));
        previous.disabled = scroller.scrollLeft <= 2;
        next.disabled = scroller.scrollLeft >= max - 2;
      };
      footer.querySelectorAll('[data-brivar-carousel-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          const scroller = activeScroller();
          if (!scroller) return;
          const slides = scroller.querySelectorAll(':scope > slideshow-slide');
          const slide = slides[0];
          let step = slide ? slide.getBoundingClientRect().width + parseFloat(getComputedStyle(scroller).gap || 0) : scroller.clientWidth * .8;
          /* BRIVAR 16/10/2026: seções .bv-paged-4 no celular passam uma página inteira (4 produtos) por clique */
          if (section.classList.contains('bv-paged-4') && window.matchMedia('(max-width: 749px)').matches) {
            step = slides[4] ? Math.abs(slides[4].getBoundingClientRect().left - slides[0].getBoundingClientRect().left) : scroller.clientWidth;
          }
          /* BRIVAR 16/10/2026: com o "encaixe" (scroll-snap) ligado, o deslize suave da setinha não andava no celular.
             Desliga o encaixe só durante o deslize, vai até a posição certa e religa. */
          const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
          const dir = button.dataset.brivarCarouselDirection === 'next' ? 1 : -1;
          let target = scroller.scrollLeft + dir * step;
          if (step > 0) target = Math.round(target / step) * step;
          target = Math.max(0, Math.min(max, target));
          scroller.style.setProperty('scroll-snap-type', 'none', 'important');
          scroller.scrollTo({ left: target, behavior: 'smooth' });
          clearTimeout(scroller.__bvSnapTimer);
          scroller.__bvSnapTimer = setTimeout(() => {
            if (Math.abs(scroller.scrollLeft - target) > 2) scroller.scrollLeft = target;
            scroller.style.removeProperty('scroll-snap-type');
            update();
          }, 650);
        });
      });
      section.querySelectorAll('slideshow-slides').forEach((scroller) => scroller.addEventListener('scroll', update, { passive: true }));
      section.querySelectorAll('[data-brivar-living-tab]').forEach((tab) => tab.addEventListener('click', () => requestAnimationFrame(update)));
      window.addEventListener('resize', update);
      requestAnimationFrame(update);
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeBrivarCollectionCarousels(), { once: true });
  } else {
    initializeBrivarCollectionCarousels();
  }
  document.addEventListener('shopify:section:load', (event) => initializeBrivarCollectionCarousels(event.target));

  } catch(e) { console.error(e); }
})();
})();
